/* global _wq */
import { _ } from '../utils.js'
import loading from '../templates/loading.js'

export default class WistiaVideo {
    constructor(el) {
        this.el = el
        this.controls = {
            play: _('video-play').nodeFrom(this.el),
            pause: _('video-pause').nodeFrom(this.el),
        }
        this.loadingContainer = _('loading-container', 'element').nodeFrom(
            this.el,
        )
        this.loaded = false
        this.scrolledTo = false
        this.scrollTrigger = this.el.dataset.scrollTrigger

        this.loadingContainer.innerHTML = loading('loading--whiteout')

        window._wq = window._wq || []

        // target our video by the first 3 characters of the hashed ID
        _wq.push({
            id: this.el.dataset.videoid,
            onReady: (video) => {
                const element = this.el
                this.loadingContainer.innerHTML = ''
                this.loaded = true
                this.controls.play.addEventListener('click', function () {
                    video.play()
                    element.classList.add(el.dataset.activeClass)
                })

                this.controls.pause.addEventListener('click', function () {
                    video.pause()
                    element.classList.remove(el.dataset.activeClass)
                })

                const handleScrollTrigger = () => {
                    const offsetTop =
                        this.el.getBoundingClientRect().top - window.innerHeight

                    if (!this.scrolledTo && offsetTop < 0) {
                        video.mute()
                        this.controls.play.dispatchEvent(new Event('click'))
                        this.scrolledTo = true
                    }
                }

                if (this.scrollTrigger === 'true') {
                    handleScrollTrigger()
                    window.addEventListener('scroll', () => {
                        handleScrollTrigger()
                    })
                }
            },
        })
    }
}
